module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loadRelatedNews) ? _c('div', {
    attrs: {
      "id": "relatedNews"
    }
  }, [_c('dl', [_vm._m(0), _vm._v(" "), _vm._l((_vm.relatedNews), function(news) {
    return _c('dd', {
      staticClass: "detail"
    }, [_c('a', {
      attrs: {
        "href": ("/news/" + (_vm.getUrlTitle(_vm.subtitChoose)) + "/" + (_vm.getUrlTitle(news.title)) + "/" + (news.aid) + "}")
      }
    }, [(news.type === 'video') ? _c('div', {
      staticClass: "detail-img-video",
      style: ({
        backgroundImage: 'url(https://allfootball-static.dongqiudi.com/web-new/static/api/images/video_play.png),url(' + news.thumb + ')'
      })
    }) : _c('div', {
      staticClass: "detail-img",
      style: ({
        backgroundImage: 'url(' + news.thumb + ')'
      })
    }), _vm._v(" "), _c('p', {
      staticClass: "detail-title",
      domProps: {
        "innerHTML": _vm._s(news.title)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "detail-time",
      domProps: {
        "innerHTML": _vm._s(news.time)
      }
    }), _vm._v(" "), (news.comments_total != 0) ? _c('span', {
      staticClass: "detail-comments",
      domProps: {
        "innerHTML": _vm._s(news.comments_total)
      }
    }) : _vm._e()])])
  })], 2)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('span', {
    staticClass: "list-title"
  }, [_vm._v("You may like")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c372762","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/relatedNews.vue
// module id = 753
// module chunks = 1